import TableCompo from '../../components/table/TableCompo';
import useCleanupOnRouteChange from '../../utilities/Cleanup';
import usePaginatedData from '../../utilities/Paginationdata';

const Driver = () => {

    const {
        data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        handleSearch,
        filterValue,
        handleFilter,
    } = usePaginatedData({
        url: `${process.env.REACT_APP_URL}/api/bulkbooking`,
        localKeys: {
            search: 'search-bulkbooking',
            filter: 'filter-bulkbooking',
            page: 'pageno-bulkbooking',
            totalPage: 'totalpage-bulkbooking',
            totalData: 'totaldata-bulkbooking',
        },
        enableSearch: true,
        enableFilter: true,
    });

    const filterOptions = [
        { value: 'verified', label: 'Verified', name: 'verification' },
        { value: 'notverified', label: 'Not verified', name: 'verification' },
        { value: 'online', label: 'Online', name: 'status' },
        { value: 'Ura premium', label: 'Ura Premium', name: 'medium' },
        { value: 'Ura Car', label: 'Ura Car', name: 'medium' },
        { value: 'Ura Bike', label: 'Ura Bike', name: 'medium' },
    ];

    useCleanupOnRouteChange(
        ['search-bulkbooking', 'filter-bulkbooking', 'totalpage-bulkbooking', 'totaldata-bulkbooking', 'pageno-bulkbooking'],
        '/bulkbooking');

    return (
        <TableCompo
            title="Bulk Booking"
            data={data}
            prevData={prevData}
            page={page}
            setPage={setPage}
            isLoading={isLoading}
            message={message}
            search={true}
            view={true}
            pagination={true}
            navPath={'details'}
            handleSearch={handleSearch}
            filter={false}
            // filterval={handleFilter}
            fil={filterValue}
            // filterOptions={filterOptions}
            inputValue={inputValue}
        />
    );

};

export default Driver;
